import { useEffect, useState } from "react";
import RightTimeApi from "@/API";
import BillingCategoryModal from "@modals/BillingCategoryModal";
import { FaPlusSquare } from "react-icons/fa";
import { toast } from "react-toastify";

export default function BillingCategoriesTab({ isActive, onToggleCollapse, updateSpinner }) {
  const [billingCategories, setBillingCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);

  useEffect(() => {
    if (isActive) fetchBillingCategories();
  }, [isActive]);

  async function fetchBillingCategories() {
    setLoading(true);
    setError(null);
    updateSpinner && updateSpinner(true);
    try {
      const resp = await RightTimeApi.getAsync("/BillingCategories");
      if (resp && resp.ok && resp.jsonData) {
        setBillingCategories(resp.jsonData);
      } else {
        console.error("Failed to load billing categories:", resp.status, resp.statusText);
        setError("Failed to load billing categories");
        toast.error("Failed to load billing categories");
      }
    } catch (error) {
      console.error("Error loading billing categories:", error);
      setError("Error loading billing categories: " + error.message);
      toast.error("Error loading billing categories: " + error.message);
    } finally {
      setLoading(false);
      updateSpinner && updateSpinner(false);
    }
  }

  async function updateListAsync() {
    setModalOpen(false);
    setEditingCategory(null);
    fetchBillingCategories();
  }

  return (
    <div className="horizontal">
      <div className="tableWrapper dimensionTable ">
        <table>
          <caption onClick={onToggleCollapse}>
            <span className="title">Billing Categories</span>
            {billingCategories ? (
              <span className="captionCount">({billingCategories.length.toString()})</span>
            ) : null}
            <span className="captionRight">
              <FaPlusSquare
                className="actionIcon plusIcon floatRight"
                title="Add Billing Category"
                onClick={e => {
                  e.stopPropagation();
                  setEditingCategory({});
                  setModalOpen(true);
                }}
              />
            </span>
          </caption>
          <thead>
            <tr>
              <th>Category Name</th>
              <th>GL Code</th>
            </tr>
          </thead>
          <tbody>
            {billingCategories.length > 0 ? (
              billingCategories.map((category) => (
                <tr key={category.id} onClick={() => { setEditingCategory(category); setModalOpen(true); }} className="pointer">
                  <td>{category.name}</td>
                  <td>{category.id || 'N/A'}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={2} className="center">No billing categories found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <BillingCategoryModal
        isOpen={modalOpen}
        category={editingCategory}
        onClose={updateListAsync}
        updateSpinner={updateSpinner}
      />
    </div>
  );
}


